import React, { Component } from "react";

import ContentLoader from "react-content-loader";
import LazyLoad from "react-lazyload";
import { NavLink } from "react-router-dom";
import Ink from "react-ink";
import axios from "axios";
import DelayLink from "../../../helpers/delayLink";
import Fade from "react-reveal/Fade";
import ProgressiveImage from "react-progressive-image";

class QuickBites extends Component {
    state = {
        quick_bites : [],
    };

    componentDidMount(){
        const userSetAddress = JSON.parse(localStorage.getItem("userSetAddress"));
        axios
        .get('https://pykin.in/public/api/get-quick-bites', {
            latitude: userSetAddress.lat,
            longitude: userSetAddress.lng, 
        })
        .then((response) => {
            const quickBites = response.data;
            if (quickBites.length) {
                this.setState({
                    quick_bites: response.data
                });
            } else {
                this.setState({
                    quick_bites: [],
                });
            }
        });
    }

    render() {

       
		return (
            <React.Fragment >
          {this.state.quick_bites.length > 0 && (
                    
                    <div className="mb-5 ml-5" style={{"fontFamily":"Poppins","fontSize":"17px","fontStyle":"normal","fontWeight":"700","lineHeight":"35px",marginTop: '23px'}}>What’s on your mind?</div>
                )}
          {this.state.quick_bites.length > 0 &&(
                <React.Fragment>
                <div className="mr-15  mt-1" style={{ display: "grid", gridTemplateColumns: "repeat(4, 2fr)", gridGap: 10 }}>
                    {this.state.quick_bites.map(quick_bite => (
                          <DelayLink
                          to={'/quick-bites/'+ quick_bite.id}
                          delay={200}
                          className="mx-2 text-center"
                          style={{ position: "relative",width: '100%',
                          height: '6rem',textAlign: "center",backgroundColor: '#fffff' }}
                      >
                          
                       

                <ProgressiveImage
						delay={100}
                        src={localStorage.getItem('cdn')+quick_bite.image}
						placeholder={'https://res.cloudinary.com/swiggy/image/upload/fl_lossy,f_auto,q_auto/portal/m/blue_placeholder'}
					>
						{(src, loading) => (
							     <img
                                 src={src}
                                 className={`slider-wrapper__img slider-cust-img custom-promo-img`}
                                 style={{
                                     height: '5rem',
                                     width: '5rem',
                                     borderRadius: '56px'
                                 }}
                             />
                             
						)}
					</ProgressiveImage>	    
                    <p style={{"fontFamily":"Poppins","fontSize":"15px","fontStyle":"normal","fontWeight":"500","marginBottom":"0px","marginTop":"2px"}}>
                        {quick_bite.name}
                    </p>
                                             {/* <Ink  background={false} /> */}

                        </DelayLink>
                    ))}
                    </div>
                </React.Fragment>
                
            )}
            </React.Fragment>
        );
    }
}

export default QuickBites;

